import {Box, Chip, Link, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useTheme} from "@mui/material/styles";


export const Legend = ({}) => {
    const theme = useTheme()

    return (
        // <Box
        //     display="flex"
        //     flexDirection="column"
        //     justifyContent="flex-start"
        // >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="left"
                p={1}
                style={{border: '.5px solid lightgrey', borderRadius: '5px', height: '76px', background: 'white'}}
            >
                <Typography variant="caption">
                    <span
                        style={{
                            height: `6px`,
                            maxWidth: '6px',
                            // background: `${theme.palette.info.light}`,
                        }}
                    >
                        ATS
                    </span>
                    {': Against the Spread'}
                </Typography>
                <Typography variant="caption">
                    <span
                        style={{
                            height: `6px`,
                            maxWidth: '6px',
                            // background: `${theme.palette.info.light}`,
                        }}
                    >
                        OV
                    </span>
                    {':  Over'}
                </Typography>
                <Typography variant="caption">
                    <span
                        style={{
                            height: `6px`,
                            maxWidth: '6px',
                            // background: `${theme.palette.info.light}`,
                        }}
                    >
                        UN
                    </span>
                    {':  Under'}
                </Typography>
                <Typography variant="caption" color={`${theme.palette.info.light}`}>
                    {/*<span*/}
                    {/*    style={{*/}
                    {/*        height: `1px`,*/}
                    {/*        maxWidth: '2px',*/}
                    {/*        background: `${theme.palette.info.light}`,*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    &nbsp; &nbsp; &nbsp;*/}
                    {/*</span>*/}
                    {'  Active Trend'}
                </Typography>
                {/*<Typography*/}
                {/*    variant="caption"*/}
                {/*>*/}
                {/*    <span*/}
                {/*        style={{*/}
                {/*            height: `6px`,*/}
                {/*            maxWidth: '6px',*/}
                {/*            background: `${theme.palette.success.light}`,*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        &nbsp; &nbsp; &nbsp;*/}
                {/*    </span>*/}
                {/*    {' Positive Streak'}*/}
                {/*</Typography>*/}
                {/*<Typography*/}
                {/*    variant="caption"*/}
                {/*>*/}
                {/*    <span*/}
                {/*        style={{*/}
                {/*            height: `6px`,*/}
                {/*            maxWidth: '6px',*/}
                {/*            background: `${theme.palette.warning.light}`,*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        &nbsp; &nbsp; &nbsp;*/}
                {/*    </span>*/}
                {/*    {' Negative Streak'}*/}
                {/*</Typography>*/}
            </Box>
        // </Box>
    )
}